import { z } from 'zod';
import { supabase } from '../../lib/supabase';

export const displayNameSchema = z.string()
  .trim()
  .min(2, 'Укажите отображаемое имя')
  .max(120, 'Не более 120 символов');

export function normalizeDisplayName(value: string): string {
  return displayNameSchema.parse(value);
}

export async function updateOwnDisplayName(value: string): Promise<string> {
  const fullName = normalizeDisplayName(value);
  const { data, error } = await supabase.rpc('update_own_display_name', { p_full_name: fullName });
  if (error) throw error;
  return data;
}
